export const endpoints = {
  topics: {
    getByCode: (code: string) => `/api/v1/internal/topics/${code}`,
    getByCompany: (shortname: string) => `/api/v1/internal/topics/company/${shortname}`,
    create: (shortname: string) => `/api/v1/internal/topics/company/${shortname}`,
    archive: (code: string) => `/api/v1/internal/topics/${code}`,
    edit: (code: string) => `/api/v1/internal/topics/${code}`,

    assignUser: (code: string) => `/api/v1/internal/topics/${code}/users`,
    unassignUser: (code: string) => `/api/v1/internal/topics/${code}/users`,
    getAssignedUsers: (code: string) => `/api/v1/internal/topics/${code}/users`,

    assignManager: (code: string) => `/api/v1/internal/topics/${code}/managers`,
    unassignManager: (code: string) => `/api/v1/internal/topics/${code}/managers`,
    getAssignedManagers: (code: string) => `api/v1/internal/topics/${code}/managers`,
    allMetrics: () => "/api/v1/internal/topics/quickmetrics"
  },

  subscriptions: {
    status: (topicCode: string) => `api/v1/internal/subscriptions/topic/${topicCode}/status`,
    subscribe: (topicCode: string) => `api/v1/internal/subscriptions/topic/${topicCode}/subscribe`,
    unsubscribe: (topicCode: string) =>
      `api/v1/internal/subscriptions/topic/${topicCode}/unsubscribe`,

    getSubscriberCount: (code: string) => `api/v1/internal/topics/${code}/subscribercount`
  },

  search: {
    searchTopicUsers: () => "api/v1/internal/search/autocomplete/topic/users"
  },

  topicWorkflows: {
    // this endpoint will return all workflows for now, not just ones made for topics
    // Right now we dont have any use for workflows other than topics though
    getAll: () => "api/v1/internal/workflows/templates"
  }
};
